import { useEffect } from 'react';
import { Link } from 'react-router';

import { useDrawsStore } from '@/entities/draw';
import { ROUTES } from '@/shared/config';
import { formatMoscowDate } from '@/shared/lib/format';
import { RADIUS, Squircle, StaticSquircle } from '@/shared/ui';

import styles from './SeasonPrizes.module.scss';

/**
 * «Призы за сезон» на главном экране (узел 438:48375).
 *
 * Дата — граница текущего Месячного цикла из `/draws/current`, по МСК.
 * Текст призов пока остаётся редакционным — пункт в `backlog.md`.
 */
export function SeasonPrizes() {
  const cycleEndsAt = useDrawsStore((state) => state.current?.cycleEndsAt);
  const loadCurrent = useDrawsStore((state) => state.loadCurrent);
  const deadline = cycleEndsAt ? formatMoscowDate(cycleEndsAt) : null;

  useEffect(() => {
    void loadCurrent();
  }, [loadCurrent]);

  return (
    <StaticSquircle
      width={390}
      height={696}
      cornerRadius={RADIUS.xl}
      className={styles.root}
      data-testid="season-prizes"
    >
      <div className={styles.shapeBox}>
        <img
          className={styles.shapeImage}
          src="/images/season-prizes/shape-bg.svg"
          alt=""
          aria-hidden
        />
      </div>
      <img
        className={styles.prizeImage}
        src="/images/season-prizes/prizes.png"
        alt=""
        aria-hidden
        data-testid="season-prizes-image"
      />

      <h2 className={styles.title}>Призы за сезон!</h2>
      <p className={styles.text}>
        {deadline ? `До ${deadline} предсказывай` : 'Предсказывай'} исходы матчей
        Лиги чемпионов, набирай очки и получай призы! Nintendo Switch и
        100&nbsp;000 Фрибетов ждут тебя
      </p>

      <Squircle asChild cornerRadius={RADIUS.xl}>
        <Link
          className={styles.cta}
          to={ROUTES.draws}
          data-testid="season-prizes-cta"
        >
          Розыгрыши
        </Link>
      </Squircle>
    </StaticSquircle>
  );
}
